// Assets/custom-soldout.js
(function () {
  // Normalise "Sold out" in any case/spacing (handles "Sold out", "SOLD OUT", etc.)
  function isSoldOutText(text) {
    return /sold\s*out/i.test((text || '').trim());
  }

  function updateButtonState(btn) {
    if (!btn) return;
    const txt = btn.textContent || '';
    const trulySoldOut = btn.disabled && isSoldOutText(txt);
    btn.classList.toggle('is-actually-sold-out', trulySoldOut);
  }

  // Attach observers to all product submit buttons (supports multiple product cards/sections)
  function wireUpAll() {
    const buttons = document.querySelectorAll('.product-form__submit[name="add"]');
    buttons.forEach((btn) => {
      // Initial state
      updateButtonState(btn);

      // Watch attribute changes (disabled) + text changes
      const mo = new MutationObserver(() => updateButtonState(btn));
      mo.observe(btn, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled'],
        childList: true,
        subtree: true,
        characterData: true,
      });

      // Safety: also re-check on clicks/changes in the form
      const form = btn.closest('form') || btn.closest('.product-form');
      if (form) {
        form.addEventListener('change', () => updateButtonState(btn), true);
        form.addEventListener('input', () => updateButtonState(btn), true);
      }
    });
  }

  // Run on load & whenever Shopify re-renders sections
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(wireUpAll);

  document.addEventListener('shopify:section:load', wireUpAll);
  document.addEventListener('shopify:section:select', wireUpAll);

  // If BeYours emits variant change events, catch them too (harmless if not present)
  ['variant:change', 'variant:changed'].forEach((evt) =>
    document.addEventListener(evt, wireUpAll)
  );
})();
